export default {
  HOST: HOST, // 域名
  advanceTime: 600 // 提前获取新token的时间(s)
}



// WEBPACK FOOTER //
// ./src/assets/js/config.js